import { Component } from '@angular/core';

@Component({
    selector: 'facebook-icon',
    templateUrl: '../../../../../../src/assets/svgs/socials/facebook.svg',
    styleUrls: ['../svg.component.scss']
})
export class FacebookIcon {

}